import type { CurrentUser } from "@/types";

/** Best available display name: first + last name, else email, else the Okta user id (`sub`). */
export function userDisplayName(user: CurrentUser | undefined): string {
  const fullName = [user?.firstName, user?.lastName]
    .filter((part): part is string => Boolean(part && part.trim()))
    .join(" ")
    .trim();
  return fullName || user?.email || user?.sub || "User";
}
